import { render } from "./NewsdicUpdate.vue?vue&type=template&id=397c7521&scoped=true"
import script from "./NewsdicUpdate.vue?vue&type=script&lang=js"
export * from "./NewsdicUpdate.vue?vue&type=script&lang=js"

import "./NewsdicUpdate.vue?vue&type=style&index=0&id=397c7521&lang=scss&scoped=true"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397c7521"]])

export default __exports__